import { render, staticRenderFns } from "./CorpPaymentForm.vue?vue&type=template&id=65545794&scoped=true&"
import script from "./CorpPaymentForm.vue?vue&type=script&lang=ts&"
export * from "./CorpPaymentForm.vue?vue&type=script&lang=ts&"
import style0 from "./CorpPaymentForm.vue?vue&type=style&index=0&id=65545794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65545794",
  null
  
)

export default component.exports